module.exports = {
  langs: ['en-US', 'es-MX']
}
